import React from "react";
import Participate from "./Assets/StepsToParticipate.jpg";
import Register from "./Assets/StepsToRegister.jpg";
import ReactPlayer from "react-player";
import Footer from "./Footer";

const Steps = () => {
  const videoUrl =
    "https://drive.google.com/file/d/1wm5RtU0-fLNbXInnOyWhhQqig9FgTC7B/view";
  return (
    <div name="Steps">
      <div
        name="Steps for Participate in Auction"
        className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 lg:-mt-6"
      >
        <h1 className="flex flex-col justify-center items-center text-3xl font-bold mb-10">
          Steps for Participate in Auction
        </h1>
        <div className="grid gap-6 row-gap-10 lg:grid-cols-2">
          <div className="lg:py-6 lg:pr-16">
            <div
              className="flex"
              data-aos="fade-down"
              data-aos-duration="500"
              data-aos-once="true"
            >
              <div className="flex flex-col items-center mr-4">
                <div>
                  <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                    <svg
                      className="w-4 text-gray-600"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <line
                        fill="none"
                        strokeMiterlimit="10"
                        x1="12"
                        y1="2"
                        x2="12"
                        y2="22"
                      />
                      <polyline
                        fill="none"
                        strokeMiterlimit="10"
                        points="19,15 12,22 5,15"
                      />
                    </svg>
                  </div>
                </div>
                <div className="w-px h-full bg-gray-300" />
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-lg font-bold">Step 1</p>
                <p className="text-gray-700">
                  If you're not logged in or signed up, please log in or create
                  an account first. Once successfully logged in, you can access
                  all the products in the{" "}
                  <b className="font-bold">Participate in Auction</b> section.
                </p>
              </div>
            </div>
            <div
              className="flex"
              data-aos="fade-down"
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="flex flex-col items-center mr-4">
                <div>
                  <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                    <svg
                      className="w-4 text-gray-600"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <line
                        fill="none"
                        strokeMiterlimit="10"
                        x1="12"
                        y1="2"
                        x2="12"
                        y2="22"
                      />
                      <polyline
                        fill="none"
                        strokeMiterlimit="10"
                        points="19,15 12,22 5,15"
                      />
                    </svg>
                  </div>
                </div>
                <div className="w-px h-full bg-gray-300" />
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-lg font-bold">Step 2</p>
                <p className="text-gray-700">
                  After making your selection of the product you wish to
                  participate in, click on{" "}
                  <b className="font-bold">Participate in Auction</b> for your
                  chosen item. This will redirect you to a new page known as the
                  Lobby.
                </p>
              </div>
            </div>
            <div
              className="flex"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <div className="flex flex-col items-center mr-4">
                <div>
                  <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                    <svg
                      className="w-4 text-gray-600"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <line
                        fill="none"
                        strokeMiterlimit="10"
                        x1="12"
                        y1="2"
                        x2="12"
                        y2="22"
                      />
                      <polyline
                        fill="none"
                        strokeMiterlimit="10"
                        points="19,15 12,22 5,15"
                      />
                    </svg>
                  </div>
                </div>
                <div className="w-px h-full bg-gray-300" />
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-lg font-bold">Step 3</p>
                <p className="text-gray-700">
                  After clicking on{" "}
                  <b className="font-bold">Participate in Auction</b>, you will
                  get a form. Please enter your full name accurately, as it will
                  be displayed in the live participant list within the room.
                  Once you have entered your full name, click on the{" "}
                  <b className="font-bold">Enter Room</b> button, which will
                  redirect you to the live auction room.
                </p>
              </div>
            </div>
            <div
              className="flex"
              data-aos="fade-down"
              data-aos-duration="1200"
              data-aos-once="true"
            >
              <div className="flex flex-col items-center mr-4">
                <div>
                  <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                    <svg
                      className="w-4 text-gray-600"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <line
                        fill="none"
                        strokeMiterlimit="10"
                        x1="12"
                        y1="2"
                        x2="12"
                        y2="22"
                      />
                      <polyline
                        fill="none"
                        strokeMiterlimit="10"
                        points="19,15 12,22 5,15"
                      />
                    </svg>
                  </div>
                </div>
                <div className="w-px h-full bg-gray-300" />
              </div>
              <div className="pt-1 pb-8">
                <p className="mb-2 text-lg font-bold">Step 4</p>
                <p className="text-gray-700">
                  After entering the room, you will witness one of our employees
                  conducting the auction while other users place bids through
                  the messaging section. You can also participate in bidding by
                  using our messaging feature. Once the auction is concluded, we
                  will end the video call, arrange for the delivery of the
                  product to the auction winner, and provide payment to the
                  product owner
                </p>
              </div>
            </div>
            <div
              className="flex"
              data-aos="fade-down"
              data-aos-duration="1300"
              data-aos-once="true"
            >
              <div className="flex flex-col items-center mr-4">
                <div>
                  <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                    <svg
                      className="w-6 text-gray-600"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <polyline
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        points="6,12 10,16 18,8"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pt-1">
                <p className="mb-2 text-lg font-bold">Done</p>
                <p className="text-gray-700" />
              </div>
            </div>
          </div>
          <div className="relative" data-aos="zoom-out" data-aos-delay="500">
            <img
              className="inset-0 object-cover object-bottom w-full rounded shadow-lg lg:absolute lg:h-full "
              src={Participate}
              alt="AuctionIMG"
            />
          </div>
        </div>
      </div>
      <div name="Steps for Register to Auction">
        <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
          <h1 className="flex flex-col justify-center items-center text-3xl font-bold mb-10">
            Steps for Register to Auction
          </h1>
          <div className="grid gap-6 row-gap-10 lg:grid-cols-2">
            <div className="lg:py-6 lg:pr-16">
              <div
                className="flex"
                data-aos="fade-down"
                data-aos-duration="500"
                data-aos-once="true"
              >
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 1</p>
                  <p className="text-gray-700">
                    Enter your full name, email address, and phone number in the
                    provided fields. Select the appropriate product category,
                    such as "Home and Kitchen," or choose "Other" if your
                    category is not listed and manually enter it. Specify the
                    product type, such as "Bowl," and provide the name of the
                    product, such as "Antique and Rare Bowl."
                  </p>
                </div>
              </div>
              <div
                className="flex"
                data-aos="fade-down"
                data-aos-duration="700"
                data-aos-once="true"
              >
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 2</p>
                  <p className="text-gray-700">
                    Enter your home address, as we will utilize this information
                    for product pick-up purposes. Enter your country Name. Next,
                    add a clear image of the product you are auctioning. This
                    image will be displayed on the product card for potential
                    bidders to see. Additionally, set the initial bid for your
                    product, determining the starting value for bidding
                  </p>
                </div>
              </div>
              <div
                className="flex"
                data-aos="fade-down"
                data-aos-duration="1000"
                data-aos-once="true"
              >
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 3</p>
                  <p className="text-gray-700">
                    Then choose your preferred payment mode. If you select Malak
                    Token, please ensure that you enter the correct Polygon
                    network account address. If you choose USDT, please enter
                    the correct network, such as Ethereum, and provide the
                    corresponding account address. By carefully completing these
                    steps, you can successfully register for the auction
                  </p>
                </div>
              </div>
              <div
                className="flex"
                data-aos="fade-down"
                data-aos-duration="1200"
                data-aos-once="true"
              >
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 4</p>
                  <p className="text-gray-700">
                    Enter the unique details or description of your product in
                    the provided description box. After providing the necessary
                    information, click on the register button. Your product
                    information will be forwarded to our admin for approval.
                    Once your product is approved, you will be able to see it in
                    the "Participate in Auction" section. If your product is
                    successfully sold during the auction, we will arrange for
                    the product to be picked up and provide you with the payment
                    for the sale.
                  </p>
                </div>
              </div>
              <div
                className="flex"
                data-aos="fade-down"
                data-aos-duration="1300"
                data-aos-once="true"
              >
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-6 text-gray-600"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <polyline
                          fill="none"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          points="6,12 10,16 18,8"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="pt-1">
                  <p className="mb-2 text-lg font-bold">Done</p>
                  <p className="text-gray-700" />
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                className="inset-0 object-cover object-bottom w-full rounded shadow-lg lg:absolute lg:h-full"
                data-aos="zoom-out"
                data-aos-delay="500"
                data-aos-once="true"
                src={Register}
                alt="AuctionIMG"
              />
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "100px" }}>
        <>
          {/* <ReactPlayer
        url="./vediofolder/flow.mp4"
        width="640px"
        height="360px"
        controls={true}
        playing={true}
        muted={true}
      /> */}

      <h1 className="flex flex-col justify-center items-center text-3xl font-bold mb-10">
          Video for More Understanding . . ! 
        </h1>
      {/* <iframe src="https://drive.google.com/file/d/1wm5RtU0-fLNbXInnOyWhhQqig9FgTC7B/preview"  style={{marginLeft:"clamp(100px,10%,1400px)",borderRadius:"20px",width:"clamp(200px,80%,80%)"}} height="480"  allow="autoplay" allowfullscreen="true"></iframe> */}
      <div style={{ position: "relative", paddingBottom: "56.25%", /* 16:9 aspect ratio */ }}>
  <iframe
    src="https://drive.google.com/file/d/1ohgN-ZF5JfrarQFx7Yp7lG9gn4b-SNGY/preview"
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      height: "70%",
      borderRadius: "20px",
      
     
    }}
    
    allow="autoplay; fullscreen"
  />
  
</div>

        </>
      </div>

      <Footer />
    </div>
  );
};

export default Steps;
